<template>
  <div ref="root" class="pl-site">
    <button
      class="pl-btn pl-btn--ghost pl-btn--sm pl-site__trigger"
      :class="{ 'is-open': open }"
      type="button"
      :aria-expanded="open ? 'true' : 'false'"
      aria-haspopup="menu"
      @click="open = !open"
    >
      <span>{{ t('navigation.site') }}</span>
      <span class="pl-disclosure__chevron" aria-hidden="true"></span>
    </button>

    <ul v-if="open" class="pl-panel pl-panel--raised pl-menu pl-site__menu" role="menu">
      <li v-for="link in links" :key="link.id" role="none">
        <router-link
          class="pl-menu__item"
          role="menuitem"
          :to="link.url"
          @click="open = false"
        >{{ t(`navigation.${link.id}`) }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { SITE_LINKS } from '@/components/Player/siteLinks.js';

const { t } = useI18n();
const route = useRoute();
const open = ref(false);
const root = ref(null);

const links = SITE_LINKS;

const onDocumentClick = (event) => {
  if (open.value && root.value && !root.value.contains(event.target)) open.value = false;
};
const onKeydown = (event) => {
  if (event.key === 'Escape') open.value = false;
};

watch(() => route.fullPath, () => { open.value = false; });

onMounted(() => {
  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeydown);
});
onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick);
  document.removeEventListener('keydown', onKeydown);
});
</script>

<style scoped>
.pl-site {
  position: relative;
  display: flex;
  align-items: center;
}

/* Flat among the flat things in the bar: the word carries it, and the panel
   opening is the confirmation. */
.pl-site__trigger {
  gap: var(--pl-gap-xs);
  border-color: transparent;
  background: transparent;
}

.pl-site__trigger.is-open {
  color: var(--pl-accent);
}

.pl-site__menu {
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 11rem;
  z-index: var(--z-overlay);
  /* Clears the bar's own padding, so the panel hangs off the bar's bottom edge
     rather than out of the middle of it. */
  margin-top: var(--pl-gap);
  padding: var(--pl-gap-xs);
}
</style>
